<template>
  <div class="flex h-full max-h-full min-h-0 flex-1 flex-col">
    <div
      v-if="$slots.title || $slots.cta"
      class="sticky inset-x-0 top-0 z-50 flex shrink-0 flex-col justify-center gap-3 border-b border-gray-300 bg-white/50 p-3 px-4 backdrop-blur md:flex-row md:items-center md:justify-between dark:border-slate-600 dark:bg-slate-700/50"
    >
      <div
        class="flex min-w-0 flex-1 items-center justify-center md:justify-start"
      >
        <slot name="title" />
      </div>
      <div v-if="$slots.cta" class="flex justify-center md:shrink-0">
        <slot name="cta" />
      </div>
    </div>
    <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
/**
 * A settings page: FM's TabContentFormComponent look (translucent sticky
 * header with the title and the buttons, grey scrolling content). It keeps
 * the former `title` / `cta` / `body` slots, so the pages are unchanged.
 */
export default {
  name: 'SettingsPageFull'
}
</script>
